export const ProductType = Object.freeze({
    Bike: 'BIKE',
    Aftermarket: 'AFTERMARKET',
    CustomWaterBottles: 'BONTRAGER_CUSTOM_BOTTLE',
    ProjectOne: 'P1_BIKE',
});
export const ProductTypeOrder = [
    ProductType.Bike,
    ProductType.Aftermarket,
    ProductType.CustomWaterBottles,
    ProductType.ProjectOne,
];